import { FraudBlocksStoreState } from "./FraudBlocksStore.types";

export const FRAUD_BLOCKS_PAGE_SIZE = 10;

export const fraudBlocksStoreState: FraudBlocksStoreState = {
  blocks: [],
  page: 0,
  size: FRAUD_BLOCKS_PAGE_SIZE,
  totalElements: 0,
  totalPages: 0,
};
